export default {
    findFilterByLabelId(filters, labelId) {
        return filters.find((filter) => {
            return filter.id === labelId;
        });
    }
}